"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRemainingActionableQualifications = exports.buildQualificationToProfessionalQualification = exports.findLowestOrderPq = void 0;
// 'Priority' order of PQ statuses
// If an option has multiple satisfying PQs, we need a heuristic to determine which to:
//  display status of
//  open pq view/edit modal with
const PQ_STATUS_ORDER_MAP = {
    approved: 1,
    review: 2,
    incomplete_pending_review: 3,
    rejected: 3,
    pending: 4,
    incomplete: 5,
    expired: 6,
    missing: 6,
    uploaded_in_error: 7,
};
// Statuses that no longer need action from the user
const PQ_STATUSES_NON_ACTIONABLE = ['approved', 'review', 'incomplete_pending_review'];
const findLowestOrderPq = (professionalQualifications) => {
    let lowestOrderPq = professionalQualifications[0];
    professionalQualifications.forEach((pq) => {
        if (PQ_STATUS_ORDER_MAP[pq.status] < PQ_STATUS_ORDER_MAP[lowestOrderPq.status]) {
            lowestOrderPq = pq;
        }
    });
    return lowestOrderPq;
};
exports.findLowestOrderPq = findLowestOrderPq;
// Link the qualifications of an option to a matching professional qualification
// Used for displaying status chips and opening the credential modal
const buildQualificationToProfessionalQualification = (optionQualifications) => {
    const qualificationToProfessionalQualification = {};
    // For every qualification in the option
    optionQualifications.forEach((option) => {
        // If there is at least one pq that satisfies the option
        if (option.satisfyingProfessionalQualifications.length > 0) {
            // Map from the option's qualification to the lowest order professional qualification (closest to approved)
            const fromQualificationId = option.qualification.id;
            const lowestOrderSatisfyingPq = (0, exports.findLowestOrderPq)(option.satisfyingProfessionalQualifications);
            const toProfessionalQualification = {
                id: lowestOrderSatisfyingPq.id,
                status: lowestOrderSatisfyingPq.status,
            };
            qualificationToProfessionalQualification[fromQualificationId] = toProfessionalQualification;
        }
    });
    return qualificationToProfessionalQualification;
};
exports.buildQualificationToProfessionalQualification = buildQualificationToProfessionalQualification;
// Used to determine if the pro has any remaining actionable qualifications
// When the professional completes an action we want to exit fully out of the complex modal if they have no more actions to take
const buildRemainingActionableQualifications = (optionQualifications) => {
    const actionableOptionQualifications = optionQualifications.filter((option) => !option.satisfyingProfessionalQualifications.some(({ status }) => PQ_STATUSES_NON_ACTIONABLE.includes(status)));
    return actionableOptionQualifications.map((option) => option.qualification);
};
exports.buildRemainingActionableQualifications = buildRemainingActionableQualifications;
